import { CSSProperties } from 'react';
import { memoize } from 'lodash';
import { Segment, SegmentWithSizes } from './types';
import { SpaceVariant, spaceVariantToValue } from '@ardoq/layout';

const measureTextBlockSize = memoize(
  ({ text, style }: { text: string; style?: CSSProperties }) => {
    if (typeof document === 'undefined') return { width: 0, height: 0 };

    const element = document.createElement('span');
    element.appendChild(document.createTextNode(text));
    if (style) {
      Object.assign(element.style, style);
    }
    document.body.appendChild(element);
    const { width, height } = element.getBoundingClientRect();
    element.remove();
    return { width: width || 0, height: height || 0 };
  },
  JSON.stringify
);

const spaceVariantToPixels = (variant?: SpaceVariant): number => {
  const value = spaceVariantToValue(variant);
  if (!value) return 0;
  return parseInt(value as string, 10);
};

export const mesureSegment = (
  segment: Segment,
  textStyles: React.CSSProperties
): SegmentWithSizes => {
  const { width, height } = measureTextBlockSize({
    text: segment.text,
    style: textStyles,
  });
  const gap = spaceVariantToPixels(segment.gap);
  return {
    ...segment,
    width: width + segment.icon.size + gap,
    height,
  };
};
